import { LocalStorage } from './local-storage';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export class LocalStorageService {
  constructor(@Inject(LocalStorage) private localStorage: any, @Inject(PLATFORM_ID) private platformId: Object) {

  }
  getLocalStorage(key: string) {
    let storage: any;
    if (isPlatformBrowser(this.platformId)) {
      storage = (<any>this.localStorage).localStorage.getItem(key);
    }

    return storage;
  }

  setLocalStorage(key: string, value: any) {
    if (isPlatformBrowser(this.platformId)) {
      (<any>this.localStorage).localStorage.setItem(key, JSON.stringify(value));
    }
  }

  removeLocalStorage(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      (<any>this.localStorage).localStorage.removeItem(key);
    }
  }
}
